/*
 * Ryan O'Dowd
 * 2025-07-08
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import Button from '@components/common/Button';
import Icon from '@react-native-vector-icons/material-design-icons';
import React from 'react';
import StartTrialButton from '@website/components/StartTrialButton';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const PricingColumn = (props: PricingColumnProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <View style={styles.titleAndCostWrapper}>
        <Text style={styles.titleText}>{props.title}</Text>
        <Text style={styles.costText}>{props.cost}</Text>
      </View>

      <View style={styles.actionButtons}>
        {props.hasBuyButton && <StartTrialButton />}
        {props.hasInfoButton && (
          <Button
            theme={styles.colors.accent}
            onPress={() => {
              // @TODO: open demo calendar?
            }}
            icon={() => <Icon name='information' size={styles.globalScale * 20} color={styles.colors.primaryExtraDark} />}
          >
            More info
          </Button>
        )}
      </View>

      <View style={styles.featuresContainer}>
        {props.features.map((feature, index) => {
          return (
            <View
              key={index}
              style={styles.featureWrapper}
            >
              <Icon name='check' size={styles.globalScale * 20} color={styles.colors.accent} />
              <Text style={styles.featureText}>{feature}</Text>
            </View>
          );
        })}
      </View>
    </View>
  );
};

class PricingColumnProps {
  title: string;
  cost: string;
  features: any[];

  hasBuyButton?: boolean;
  hasInfoButton?: boolean;
};

export default PricingColumn;
